module.exports = "https://www.gc-pro.gnp.com.mx/d692de862e21d7bde066c25c6f6dcd72.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/youtube.png
// module id = 8181
// module chunks = 0